import React, {Component} from 'react';
import PropTypes from 'prop-types';

import FeatureToggle from '@stubhub/react-feature-toggle';
import InterceptModal from '@stubhub/react-intercept-modal';
import LayoutHandler from '@stubhub/react-mobile-layout-handler';
import Spinner from '@stubhub/react-spinner';

import FEATURE_FLAGS from '../../../../utils/featureFlags';
import {importantMessagesCookieExists, setImportantMessagesCookie} from '../../../../utils/importantMessagesUtils';
import DisclaimerButton from '../../components/react-disclaimer-button';
import EventFooterBottom from '../../components/react-event-footer-bottom';
import BuildYourOrder from '../../containers/react-build-your-order';
import EventInfoHeader from '../../containers/react-event-info-header';
import ListingsFilter from '../../containers/react-listings-filter';
import {NoListingEvent, NoListingFilter} from '../../containers/react-no-listings';
import RoyalMap from '../../containers/react-royal-map';
import TicketList from '../../containers/react-ticket-list';

import './index.scss';

function getInitialFilterState() {
  if (__CLIENT__) {
    return document.referrer.startsWith(document.location.origin) && document.referrer.includes(!'event');
  }

  return false;
}

// This mapping is necessary to connect the component import to string based declaration from props
const sectionComponents = {
  TicketList,
  BuildYourOrder,
  RoyalMap,
  ListingsFilter,
};

export const handleIsImportantInfoModalOpen = (cookies, {showDisclaimer, forceShowDisclaimer, eventId}) => {
  return (showDisclaimer && !importantMessagesCookieExists(cookies, eventId)) || forceShowDisclaimer;
};

@LayoutHandler()
class EventRoyal extends Component {
  constructor(props, context) {
    super(props, context);
    const {cookies} = this.context;
    const {eventId, showDisclaimer, forceShowDisclaimer} = this.props;
    this.state = {
      showFilter: getInitialFilterState(),
      isImportantInfoModalOpen: handleIsImportantInfoModalOpen(cookies, {
        showDisclaimer,
        forceShowDisclaimer,
        eventId,
      }),
    };
  }

  static contextTypes = {
    globalRegistry: PropTypes.object.isRequired,
    cookies: PropTypes.object,
  };

  onCloseBYO = (e) => {
    const {onCloseBYO} = this.props;
    onCloseBYO(e);
  };

  handleSelectTicket = (...args) => {
    const {handleSelectTicket} = this.props;
    handleSelectTicket && handleSelectTicket(...args);
    // This.toggleHelloAnimation();
  };

  /*
   * ToggleHelloAnimation() {
   *   if (__CLIENT__ && sessionStorage) {
   *     const eventIdsSeenHelloAnimation = JSON.parse(sessionStorage.getItem('eventIdsDrawerHello')) || [];
   *     const showDrawerSpring = eventIdsSeenHelloAnimation.filter((id) => id === this.props.eventId).length === 0;
   *     if (showDrawerSpring) {
   *       sessionStorage.setItem('eventIdsDrawerHello', JSON.stringify([...eventIdsSeenHelloAnimation, this.props.eventId]));
   *     }
   *   }
   * }
   */

  toggleFilterState = () => {
    const {showFilter} = this.state;

    this.setState({
      showFilter: !showFilter,
    });
    // This.toggleHelloAnimation();
  };

  onResetFilter = (...args) => {
    const {onResetFilter} = this.props;
    onResetFilter(...args);
  };

  componentDidMount() {
    document && document.body.classList.add('EventRoyalBody--mobile');
  }

  componentDidUpdate(prevProps) {
    const {showDisclaimer, buyerMessages, forceShowDisclaimer, eventId} = this.props;
    if (
      prevProps.showDisclaimer !== showDisclaimer ||
      prevProps.buyerMessages !== buyerMessages ||
      prevProps.forceShowDisclaimer !== forceShowDisclaimer
    ) {
      const {cookies} = this.context;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isImportantInfoModalOpen: handleIsImportantInfoModalOpen(cookies, {
          showDisclaimer,
          forceShowDisclaimer,
          eventId,
        }),
      });
    }
  }

  /*
   * Used for animated and draggable drawer not currently displayed to users
   * showDrawerSpring() {
   *   let showDrawerSpring = true;
   *   if (__CLIENT__ && sessionStorage) {
   *     const eventIdsSeenHelloAnimation = JSON.parse(sessionStorage.getItem('eventIdsDrawerHello')) || [];
   *     showDrawerSpring = eventIdsSeenHelloAnimation.filter((id) => id === this.props.eventId).length === 0;
   *   }
   *
   *   return showDrawerSpring ? 'spring' : 'no_spring';
   * }
   */

  componentWillUnmount() {
    // This.props.destroy();
    document && document.body.classList.remove('EventRoyalBody--mobile');
    if (__CLIENT__) {
      // This.toggleHelloAnimation();
    }
  }

  renderFooterNonGA() {
    const {globalRegistry} = this.context;
    const {listings = {}, partner, buyerMessages, layoutConfig, selectedCurrency} = this.props;
    const {filterCount} = listings;
    const ContentScroll = sectionComponents[layoutConfig.ContentScroll];
    const isAdvisoryCurrencyEnabled = globalRegistry.getFeatureValue(FEATURE_FLAGS.common.advisory.enabled);

    return (
      <section className="EventRoyal__Mobile__listings_section">
        <EventFooterBottom
          isAdvisoryCurrencyEnabled={isAdvisoryCurrencyEnabled}
          selectedCurrency={selectedCurrency}
          onClickFilter={this.toggleFilterState}
          filterCount={filterCount}
        />
        {/* ContentScroll Panel component abstraction */}
        {ContentScroll && (
          <ContentScroll handleSelectTicket={this.handleSelectTicket} partner={partner} buyerMessages={buyerMessages} />
        )}
      </section>
    );
  }

  renderFooterGA() {
    const {layoutConfig, buyerMessages} = this.props;
    const ContentScroll = sectionComponents[layoutConfig.ContentScroll];

    return (
      <>
        <EventFooterBottom onClickFilter={this.toggleFilterState} />
        <hr className="EventRoyal__border" />
        {/* ContentScroll Panel component abstraction */}
        {ContentScroll && (
          <ContentScroll
            onClickFilter={this.toggleFilterState}
            handleSelectTicket={this.handleSelectTicket}
            buyerMessages={buyerMessages}
          />
        )}
      </>
    );
  }

  handleCloseImportantInfoModal = () => {
    const {eventId, closeDisclaimer} = this.props;
    const {cookies} = this.context;
    const {importantMessagesCookie} = this.state;
    if (!importantMessagesCookie) {
      setImportantMessagesCookie(cookies, eventId);
    }
    closeDisclaimer();
  };

  render() {
    const {
      eventId,
      hasTickets,
      listingLoading,
      totalListings,
      averageTicketPriceWithCurrency,
      listingId,
      showBYO,
      device,
      isGA,
      selectedTicketRank,
      partner,
      layoutConfig,
      currentLocation = {},
      defaultWebTLD = '',
      buyerMessages,
      showImportantInfoModal,
      forceOpenDisclaimer,
      goBack,
      mapInventoryLoading,
      btToken,
      paypalClientId,
      eventCurrency,
      paypalError,
    } = this.props;
    const {showFilter, isImportantInfoModalOpen} = this.state;
    let eventContent = null;

    const BYOTakeover = sectionComponents[layoutConfig.BYOTakeover];
    const SplashScreen = sectionComponents[layoutConfig.SplashScreen];
    const ContentWindow = sectionComponents[layoutConfig.ContentWindow];

    if (showBYO && hasTickets && BYOTakeover) {
      /* BYOTakeover Panel component abstraction */
      eventContent = (
        <BYOTakeover
          listingId={listingId}
          onCloseBYO={this.onCloseBYO}
          selectedTicketRank={selectedTicketRank}
          deviceType={device.type}
          partner={partner}
          btToken={btToken}
          paypalClientId={paypalClientId}
          eventCurrency={eventCurrency}
          paypalError={paypalError}
        />
      );
    } else if (hasTickets !== undefined && !hasTickets) {
      eventContent = (
        <>
          <EventInfoHeader
            className="NoListingsEventView__byoFakeHeader-margin"
            goBack={goBack}
            showImportantInfoModal={showImportantInfoModal}
            buyerMessages={buyerMessages}
            handleImportantIconClick={forceOpenDisclaimer}
          />
          <NoListingEvent eventId={eventId} />;
        </>
      );
    } else if (!showFilter && !listingLoading && typeof totalListings === 'number' && totalListings === 0) {
      eventContent = (
        <>
          <EventInfoHeader
            goBack={goBack}
            showImportantInfoModal={showImportantInfoModal}
            buyerMessages={buyerMessages}
            handleImportantIconClick={forceOpenDisclaimer}
          />

          <NoListingFilter onResetFilter={this.onResetFilter} />
        </>
      );
    } else if (showFilter && SplashScreen) {
      eventContent = (
        <>
          {/* SplashScreen Panel component abstraction */}
          <SplashScreen
            eventId={eventId}
            averageTicketPriceWithCurrency={averageTicketPriceWithCurrency}
            onCloseFilter={this.toggleFilterState}
            onResetFilter={this.onResetFilter}
            goBack={goBack}
            isGA={isGA}
          />
        </>
      );
    } else if (hasTickets) {
      eventContent = (
        <>
          <div className="EventRoyal__Mobile__eventInfo">
            <span className="EventRoyal__eventInfoHeader">
              <EventInfoHeader
                goBack={goBack}
                showImportantInfoModal={showImportantInfoModal}
                buyerMessages={buyerMessages}
                handleImportantIconClick={forceOpenDisclaimer}
              />
            </span>

            {mapInventoryLoading && <Spinner />}
            {/* ContentWindow Panel component abstraction */}
            <ContentWindow />
            {isGA && <hr className="EventRoyal__border" />}
          </div>
          <DisclaimerButton
            enabled={isImportantInfoModalOpen}
            close={this.handleCloseImportantInfoModal}
            message={buyerMessages}
          />
          {isGA ? this.renderFooterGA() : this.renderFooterNonGA()}
        </>
      );
    }

    return (
      <div className="EventRoyal__container EventRoyal__Mobile">
        {eventContent}
        <FeatureToggle name="common.enableInterceptModalForCA">
          <InterceptModal currentLocation={currentLocation} defaultWebTLD={defaultWebTLD} />
        </FeatureToggle>
      </div>
    );
  }
}

EventRoyal.propTypes = {
  /** Average ticket price with currency object */
  averageTicketPriceWithCurrency: PropTypes.object,

  /** Braintree token */
  btToken: PropTypes.string,

  /** Important messages for the event */
  buyerMessages: PropTypes.array,

  /** Function called when important message is closed */
  closeDisclaimer: PropTypes.func.isRequired,

  /** Current location object */
  currentLocation: PropTypes.object,

  /** Default TLD for the site */
  defaultWebTLD: PropTypes.string,

  /** Device object with type info */
  device: PropTypes.object.isRequired,

  /** The event currency */
  eventCurrency: PropTypes.string,

  /** The event id */
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** If the important message should be shown regardless of the cookie value */
  forceShowDisclaimer: PropTypes.bool,

  /** Function called when important message icon is clicked */
  forceOpenDisclaimer: PropTypes.func,

  /** Function to call when back is clicked */
  goBack: PropTypes.func,

  /** Is general admission? */
  isGA: PropTypes.bool,

  /** The layout config for event page */
  layoutConfig: PropTypes.object,

  /** Event listings */
  listings: PropTypes.array,

  /** Is map inventory loading? */
  mapInventoryLoading: PropTypes.bool,

  /** Handler function invoked when a function is selected */
  handleSelectTicket: PropTypes.func,

  /** If the event has tickets */
  hasTickets: PropTypes.bool,

  /** Selected listing id */
  listingId: PropTypes.number,

  /** If the listing is loading */
  listingLoading: PropTypes.bool,

  /** Partner id */
  partner: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Paypal client id */
  paypalClientId: PropTypes.string,

  /** If there's any paypal loading error */
  paypalError: PropTypes.bool,

  /** Selected currency code */
  selectedCurrency: PropTypes.string,

  /** Ticket rank of the selected listing */
  selectedTicketRank: PropTypes.number,

  /** If BYO should be shown */
  showBYO: PropTypes.bool,

  /** If there is any important message to be shown */
  showDisclaimer: PropTypes.bool,

  /** If the important message should be shown in a modal */
  showImportantInfoModal: PropTypes.bool,

  /** Total number of listings */
  totalListings: PropTypes.number,

  /** Function to call when BYO is closed */
  onCloseBYO: PropTypes.func.isRequired,

  /** Function to call when filter is reset */
  onResetFilter: PropTypes.func.isRequired,
};

export default EventRoyal;
